import React, { useEffect, useState } from "react";
import "react-phone-number-input/style.css";
import PhoneInput, {
    formatPhoneNumberIntl,
    isValidPhoneNumber,
} from "react-phone-number-input";
import { Information } from "assets/icons";

/** Même gabarit que les inputs profil : h-10, text-sm, bordure gray-200. */
const SelectPhone = ({ phoneValue, setPhoneValue, disabledP }) => {
    const [value, setValue] = useState("");
    const [validPhone, setValidPhone] = useState(false);

    useEffect(() => {
        if (validPhone) {
            setPhoneValue(
                formatPhoneNumberIntl(`${value}`).replace(/\s+/g, "")
            );
        }
    }, [validPhone, setPhoneValue, value]);

    useEffect(() => {
        setValidPhone(isValidPhoneNumber(`${value}`));
    }, [value]);

    useEffect(() => {
        if (phoneValue?.length > 0) {
            setValue(formatPhoneNumberIntl(phoneValue));
        }
    }, [phoneValue]);

    const shellClass = [
        "w-full h-10 flex items-center rounded-lg border px-3",
        "text-sm text-gray-900",
        disabledP
            ? "bg-gray-100 border-gray-200 cursor-not-allowed"
            : "bg-white border-gray-200",
    ].join(" ");

    const inputClassName =
        "PhoneInputInput min-w-0 flex-1 !border-0 !bg-transparent !shadow-none " +
        "!p-0 !m-0 !h-8 !text-sm !text-gray-900 !leading-none " +
        "placeholder:!text-gray-500 outline-none ring-0 " +
        "focus:!ring-0 focus:!outline-none";

    return (
        <>
            <div className={shellClass}>
                <PhoneInput
                    className="PhoneInput flex h-full w-full min-w-0 items-center gap-2 !border-0 !bg-transparent !p-0"
                    inputClassName={inputClassName}
                    defaultCountry="FR"
                    placeholder="Indiquer votre numéro"
                    value={value}
                    onChange={setValue}
                    disabled={!!disabledP}
                />
            </div>
            {!validPhone && value?.toString().length > 0 ? (
                <p className="mt-1 flex flex-row items-center gap-4 text-yellow-500">
                    <span>
                        <Information wh={14} color={"#FF9600"} />
                    </span>
                    Numéro invalide
                </p>
            ) : null}
        </>
    );
};

export default SelectPhone;
